import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type CacheEntry<T = any> = {
  data: T
  updatedAt: number
}

interface AnalyticsSalesCacheState {
  cache: Record<string, CacheEntry<any>>
  hydrated: boolean
  setCache: (key: string, data: any) => void
  getCache: (key: string) => CacheEntry<any> | undefined
  clear: () => void
  setHydrated: (value: boolean) => void
}

export const useAnalyticsSalesCacheStore = create<AnalyticsSalesCacheState>()(
  persist(
    (set, get) => ({
      cache: {},
      hydrated: false,

      setCache: (key, data) =>
        set(state => ({
          cache: {
            ...state.cache,
            [key]: {
              data,
              updatedAt: Date.now()
            }
          }
        })),

      getCache: key => get().cache[key],

      clear: () => set({ cache: {} }),

      setHydrated: value => set({ hydrated: value })
    }),
    {
      name: 'analytics-sales-cache',
      partialize: (state) => ({
        cache: state.cache
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHydrated?.(true)
      }
    }
  )
)